import { IBaseState } from "../..";
import {
    IPropertyModel,
    IPropertyMultModel,
    IPropertyDescriptionModel,
    IPropertyCreativeObject,
    IPropertyRoomModel,
    IPropertySmartSuggest,
    IEnvironmentPictureType,
    IPropertyEnvironmentPictureStorage,
    ISummaryCounterSearchProperty,
    PropertyModel,
    PropertyCreativeObject,
    PropertyRoomModel,
    EnvironmentPictureType
} from "../../../models/property";
import { ILookupPropertyEnvironment } from "../../../models/lookup/property.environment.model";
import {
    IPropertyEnvironmentPointMapList,
    PropertyEnvironmentPointMapList
} from "../../../models/property/property-environment-point.model";
import { IPropertyDocumentRequestInfoModel } from "../../../models/property/property-document-request-info.model";
import {
    IPropertyEnvironmentAddressModel,
    PropertyEnvironmentAddressModel
} from "../../../models/property/property-environment.address.model";
import { IMediaPubPlansArray } from "../../../models/property/property-publish-plan.model";
import {
    IMijnVerhuisRequestModel,
    MijnVerhuisRequestModel
} from "../../../models/property/property-mijnverhuis.model";
import {
    ISmoovedRequestModel,
    SmoovedRequestModel
} from "../../../models/property/property-smooved.model";
import {
    IKeuringPublishInfoRequest,
    KeuringPublishInfoRequest
} from "../../../models/property/property-keuring-platform.model";
import {
    IKorfineRequestModel,
    KorfineRequestModel
} from "../../../models/property/property-korfine.model";

export interface IPropertyEditState extends IBaseState<{}, {}> {
    projectService?: Object;
    property?: IPropertyModel;
    originalProperty?: IPropertyModel;
    propertySubCategory?: IPropertyMultModel;
    propertyDescription?: IPropertyDescriptionModel;
    creativeObject?: IPropertyCreativeObject;
    previouseStreetLookupKey?: string;
    currentRoom?: IPropertyRoomModel;
    previousRoom?: IPropertyRoomModel;
    listOfCriterias?: IPropertySmartSuggest[];
    prevSmartSearchKeyword?: string;
    environmentPictureType?: IEnvironmentPictureType;
    listOfSelectPropertyEnvironment?: ILookupPropertyEnvironment[];
    listOfPropertyEnvironmentPictureStorage?: IPropertyEnvironmentPictureStorage[];
    ListOfPropertyEnvironmentPointMapList?: IPropertyEnvironmentPointMapList;
    summaryCounterSearchProperty?: ISummaryCounterSearchProperty;
    environmentAddress?: IPropertyEnvironmentAddressModel;
    MediaPubPlans?: IMediaPubPlansArray[];
    initHeritages?: Array<string>;
    mijnverhuis?: IMijnVerhuisRequestModel;
    smooved?: ISmoovedRequestModel;
    keuringPlatform?: IKeuringPublishInfoRequest;
    korfine?: IKorfineRequestModel;
    propertyRequestDocumentInfo?: IPropertyDocumentRequestInfoModel;
    isSaving?: boolean;
}

export class PropertyEditState implements IPropertyEditState {
    service?: {};
    projectService?: Object;
    property?: IPropertyModel;
    originalProperty?: IPropertyModel;
    propertySubCategory?: IPropertyMultModel;
    propertyDescription?: IPropertyDescriptionModel;
    creativeObject?: IPropertyCreativeObject;
    previouseStreetLookupKey?: string;
    currentRoom?: IPropertyRoomModel;
    previousRoom?: IPropertyRoomModel;
    listOfCriterias?: IPropertySmartSuggest[];
    prevSmartSearchKeyword?: string;
    environmentPictureType?: IEnvironmentPictureType;
    listOfSelectPropertyEnvironment?: ILookupPropertyEnvironment[];
    listOfPropertyEnvironmentPictureStorage?: IPropertyEnvironmentPictureStorage[];
    ListOfPropertyEnvironmentPointMapList?: IPropertyEnvironmentPointMapList;
    summaryCounterSearchProperty?: ISummaryCounterSearchProperty;
    environmentAddress?: IPropertyEnvironmentAddressModel;
    MediaPubPlans?: IMediaPubPlansArray[];
    initHeritages?: Array<string>;
    mijnverhuis?: IMijnVerhuisRequestModel;
    smooved?: ISmoovedRequestModel;
    keuringPlatform?: IKeuringPublishInfoRequest;
    korfine?: IKorfineRequestModel;
    isSaving: boolean;

    constructor(options: IPropertyEditState) {
        this.service = options.service;
        this.projectService = options.projectService;
        this.property = new PropertyModel({
            Id: 0,
            Documents: [],
            Pictures: [],
            Relations: [],
            ProjectEvolutionPictures: [],
            ProjectEnvironmentPictures: [],
            ProjectFeatures: [],
            LinkedUnits: [],
            Videos: [],
            Rooms: []
        });
        this.propertySubCategory = null;
        this.propertyDescription = null;
        this.creativeObject = new PropertyCreativeObject();
        this.originalProperty = null;
        this.previouseStreetLookupKey = null;
        this.currentRoom = new PropertyRoomModel({
            FloorId: 0,
            Width: null,
            Length: null
        });
        this.previousRoom = new PropertyRoomModel({ FloorId: 0 });
        this.listOfCriterias = options.listOfCriterias;
        this.environmentPictureType = new EnvironmentPictureType({});
        this.listOfSelectPropertyEnvironment = [];
        this.listOfPropertyEnvironmentPictureStorage = [];
        this.ListOfPropertyEnvironmentPointMapList = new PropertyEnvironmentPointMapList(
            {}
        );

        this.summaryCounterSearchProperty = null;
        this.environmentAddress = new PropertyEnvironmentAddressModel({});
        this.mijnverhuis = new MijnVerhuisRequestModel({});
        this.smooved = new SmoovedRequestModel({});
        this.korfine = new KorfineRequestModel({});
        this.keuringPlatform = new KeuringPublishInfoRequest({});
        this.MediaPubPlans = [];
        this.isSaving = false;
    }
}
